<template>
  <page-wrapper :title="title">
    <div v-if="project" class="container">
      <div class="row">
        <div class="col-lg-3 detail">
          <div class="project-group mb-3">
            <img :src="projectGroup.logo" class="logo img-fluid" />
            <div class="name">{{ projectGroup.name }}</div>
          </div>
          <div v-for="detail in projectDetail" :key="detail.label" class="mb-3">
            <div class="label">{{ detail.label }}</div>
            <div class="text">{{ detail.text }}</div>
          </div>
          <div class="label mb-1">รูปปก</div>
          <img :src="projectCoverImageUrl" class="img-fluid mb-3 cover" />
        </div>
        <div class="col-lg-9">
          <div class="sub-route">
            <router-link
              v-for="route in subRoutes"
              :key="route.label"
              :to="route.to"
              class="route"
              exact-active-class="active"
              >{{ route.label }}</router-link
            >
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    PageWrapper
  },
  data() {
    const title = "ข้อมูลโครงการ";
    const project = null;
    const subRoutes = [
      {
        label: "Building Status",
        to: { name: "ProjectBuildingStatusPage", params: this.$route.params }
      },
      {
        label: "Phone Directory",
        to: { name: "ProjectPhoneDirectoryPage", params: this.$route.params }
      }
    ];

    return { title, project, subRoutes };
  },
  computed: {
    projectDetail() {
      if (!this.project) {
        return [];
      }

      const projectType = { H: "แนวสูง", L: "แนวราบ" };

      const {
        project_name: name,
        project_code: code,
        project_type: typeKey,
        address_road: addressRoad = "",
        pre_tumbon: preTumbon = "",
        tumbon_name: tumbonName = "",
        pre_amphur: preAmphur = "",
        amphur_name: amphurName = "",
        province_name: provinceName = "",
        zip_code: zipCode = ""
      } = this.project;
      const type = projectType[typeKey];
      const addressText = [
        addressRoad,
        preTumbon,
        tumbonName,
        preAmphur,
        amphurName,
        provinceName,
        zipCode
      ]
        .map(t => (t ? t.trim() : ""))
        .filter(t => t !== "")
        .join(" ")
        .trim();
      const address = addressText === "" ? "-" : addressText;

      return [
        { label: "ชื่อ", text: name },
        { label: "รหัส", text: code },
        { label: "ประเภท", text: type },
        { label: "ที่อยู่", text: address }
      ];
    },
    projectCoverImageUrl() {
      const url = this.project
        ? this.project.project_cover
        : "https://placehold.co/1280x720";

      return url;
    },
    projectGroup() {
      if (!this.project) {
        return { name: "", logo: "" };
      }

      const name = this.project.project_group;
      const logo = this.project.project_icon;

      return {
        name,
        logo
      };
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      this.setupData();
    },
    async setupData() {
      const project = await this.fetchData();

      this.project = project;
    },
    async fetchData() {
      const projectId = this.$route.params.id;
      const response = await baanRueJaiClient.admin.projects.get(projectId);

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.container {
  padding-top: $space;
  padding-bottom: $space;
}

.detail {
  border-right: $border;
}

.label {
  font-size: 14px;
  color: #666;
}

.text {
  font-size: 16px;
  color: black;
}

.project-group {
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-gap: 15px;
  align-items: center;

  > .logo {
    border: $border;
    border-radius: 6px;
  }
}

.cover {
  border: $border;
  border-radius: 6px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
}

.actions {
  text-align: right;
}

.btn-remove {
  float: left;
}

.sub-route {
  border-bottom: 1px solid #ddd;
  margin-bottom: 2rem;

  > .route {
    display: inline-block;

    border-bottom: 3px solid transparent;
    padding: 0.85rem 1rem;

    &:hover {
      color: black;
    }

    &.active {
      font-weight: bold;
      border-bottom-color: #e27024;
    }
  }
}
</style>
